export enum OnboardingFlow {
  COMPOSE_FIRST_TEAM = 'compose_first_team',
  COMMON_GAME = 'common_game',
}
